<template>
    <div class="judges-wrap">
        <div class="judges-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>场次专区</el-breadcrumb-item>
                <el-breadcrumb-item>场次管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="action">
                <el-button size="small" type="primary" @click="showdialogScene">新建场次</el-button>
            </div>
        </div>
        <div class="judges-table">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="scene" label="场次"> </el-table-column>
                <el-table-column prop="name" label="类目"> </el-table-column>
                <el-table-column
                    prop="duration"
                    label="互联网产品开发"
                    v-if="enableModules == 0 || enableModules == 1"
                >
                    <template slot-scope="scope"> {{ scope.row.prodevTotal }}分钟 </template>
                </el-table-column>
                <el-table-column
                    prop="duration"
                    label="视觉营销"
                    v-if="enableModules == 0 || enableModules == 2"
                >
                    <template slot-scope="scope"> {{ scope.row.storeTotal }}分钟 </template>
                </el-table-column>
                <el-table-column
                    prop="duration"
                    label="网店营销与运营推广"
                    v-if="enableModules == 0 || enableModules == 3"
                >
                    <template slot-scope="scope">
                        <p>
                            开店：{{ scope.row.operateTime.storeTime }} | 采购：{{
                                scope.row.procureTotalTime
                            }}
                        </p>
                        <p>
                            推广：{{ scope.row.operateTime.promotionTime }} | 运营：{{
                                scope.row.operateTotalTime
                            }}
                        </p>
                        <p>财务：{{ scope.row.financeTotalTime }}</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                            @click="handleViewClick(scope.row.raceID)"
                            type="primary"
                            plain
                            size="small"
                            >查看</el-button
                        >
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="judges-page">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="currentpage"
                    :page-size="pagesize"
                    layout="total, prev, pager, next"
                    :total="pagetotal"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog
            class="live-dialog"
            title="新建场次"
            :visible.sync="dialogSceneVisible"
            v-if="dialogSceneVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="800px"
            ><el-row>
                <el-form
                    :model="ruleAddSceneForm"
                    :rules="rules"
                    ref="ruleAddSceneForm"
                    label-width="150px"
                    class="judges-form"
                >
                    <el-form-item label="类目" prop="categoryID">
                        <el-select v-model="ruleAddSceneForm.categoryID" placeholder="请选择类目">
                            <el-option
                                v-for="item in categorys"
                                :key="item.categoryID"
                                :label="item.name"
                                :value="item.categoryID"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="场次人数" prop="personnumber">
                        <el-input
                            v-model.number="ruleAddSceneForm.personnumber"
                            placeholder="请输入场次人数"
                            maxlength="4"
                            ><template slot="append">人</template></el-input
                        >
                    </el-form-item> -->
                    <el-form-item label="互联网产品开发" prop="prodevTotal">
                        <el-input
                            v-model.number="ruleAddSceneForm.prodevTotal"
                            placeholder="请输入时长"
                            maxlength="4"
                            ><template slot="append">分钟</template></el-input
                        >
                    </el-form-item>

                    <el-form-item label="视觉营销" prop="storeTotal">
                        <el-input
                            v-model.number="ruleAddSceneForm.storeTotal"
                            placeholder="请输入时长"
                            maxlength="4"
                            ><template slot="append">分钟</template></el-input
                        >
                    </el-form-item>
                    <el-form-item label="轮次" prop="roundCount">
                        <el-input
                            v-model.number="ruleAddSceneForm.roundCount"
                            placeholder="请输入轮次"
                            maxlength="4"
                            ><template slot="append">轮</template></el-input
                        >
                    </el-form-item>

                    <el-col :span="12">
                        <el-form-item label="初始资金" prop="operateFund">
                            <el-input
                                v-model.number="ruleAddSceneForm.operateFund"
                                placeholder="请输入时长"
                                maxlength="4"
                                ><template slot="append">元</template></el-input
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开店时长" prop="stroeTotalTime">
                            <el-input
                                v-model.number="ruleAddSceneForm.stroeTotalTime"
                                placeholder="请输入时长"
                                maxlength="4"
                                ><template slot="append">分钟</template></el-input
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="采购时长" prop="procureTotalTime">
                            <el-input
                                v-model.number="ruleAddSceneForm.procureTotalTime"
                                placeholder="请输入时长"
                                maxlength="4"
                                ><template slot="append">分钟</template></el-input
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="推广时长" prop="promotionTotalTime">
                            <el-input
                                v-model.number="ruleAddSceneForm.promotionTotalTime"
                                placeholder="请输入时长"
                                maxlength="4"
                                ><template slot="append">分钟</template></el-input
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="运营时长" prop="operateTotalTime">
                            <el-input
                                v-model.number="ruleAddSceneForm.operateTotalTime"
                                placeholder="请输入时长"
                                maxlength="4"
                                ><template slot="append">分钟</template></el-input
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="财务时长" prop="financeTotalTime">
                            <el-input
                                v-model.number="ruleAddSceneForm.financeTotalTime"
                                placeholder="请输入时长"
                                maxlength="4"
                                ><template slot="append">分钟</template></el-input
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="每轮时长">
                            <i class="el-icon-time"></i>
                            <strong class="text-green-500 ml-2">{{ totalCycleTime }}</strong> 分钟
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总时长">
                            <i class="el-icon-time"></i>
                            <strong class="text-green-500 ml-2">{{ totalRoundTime }}</strong> 分钟
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogSceneVisible = false">取 消</el-button>
                <el-button type="warning" @click="submitAddSceneForm('ruleAddSceneForm')"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getCategorys,
    addRaceRecords,
    getRaceRecordList,
    getRaceRecordListCount
} from '@/api/judges';
import { getRaceManager } from '@/api/races.js';
import { math } from '@/uitls/math';
export default {
    name: 'scenemanagement',
    data() {
        var checkTime = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入延长时长'));
            }
            if (!Number.isInteger(value)) {
                callback(new Error('时长必须为数字值'));
            } else {
                if (value < 1) {
                    callback(new Error('延长时长必须大于1'));
                } else {
                    callback();
                }
            }
        };

        return {
            dialogSceneVisible: false, //新建场次
            currentpage: 1,
            pagesize: 10,
            pagetotal: 0,
            tableData: [],
            categorys: [],
            ruleAddSceneForm: {
                categoryID: '',
                prodevTotal: '90',
                storeTotal: '150',
                operateFund: '500',
                roundCount: '5',
                stroeTotalTime: '5',
                procureTotalTime: '5',
                promotionTotalTime: '15',
                operateTotalTime: '3',
                financeTotalTime: '2',
                personnumber: 0,
                TeamID: 0
            },
            rules: {
                categoryID: [{ required: true, message: '请选择类目', trigger: 'change' }],
                prodevTotal: [
                    { required: true, message: '请输入互联网产品开发时长', trigger: 'blur' }
                ],
                storeTotal: [{ required: true, message: '请输入视觉营销时长', trigger: 'blur' }],
                operateFund: [{ required: true, message: '请输入初始资金', trigger: 'blur' }],
                roundCount: [{ required: true, message: '请输入轮次', trigger: 'blur' }],
                stroeTotalTime: [{ required: true, message: '请输入开店时长', trigger: 'blur' }],
                procureTotalTime: [{ required: true, message: '请输入采购时长', trigger: 'blur' }],
                promotionTotalTime: [
                    { required: true, message: '请输入推广时长', trigger: 'blur' }
                ],
                operateTotalTime: [{ required: true, message: '请输入运营时长', trigger: 'blur' }],
                financeTotalTime: [{ required: true, message: '请输入财务时长', trigger: 'blur' }],
                personnumber: [
                    { required: true, message: '请输入场次人数', trigger: 'blur' },
                    { validator: checkTime, trigger: 'blur' }
                ]
            },
            enableModules: -1
        };
    },
    computed: {
        totalCycleTime() {
            let roundCycleTime = [
                this.ruleAddSceneForm.stroeTotalTime ? this.ruleAddSceneForm.stroeTotalTime : 0,
                this.ruleAddSceneForm.procureTotalTime ? this.ruleAddSceneForm.procureTotalTime : 0,
                this.ruleAddSceneForm.promotionTotalTime
                    ? this.ruleAddSceneForm.promotionTotalTime
                    : 0,
                this.ruleAddSceneForm.operateTotalTime ? this.ruleAddSceneForm.operateTotalTime : 0,
                this.ruleAddSceneForm.financeTotalTime ? this.ruleAddSceneForm.financeTotalTime : 0
            ].reduce((a, b) => {
                if (/\d+/.test(a) && /\d+/.test(b)) {
                    return math.add(a, b);
                }
                return 0;
            }, 0);

            return math.multiply(roundCycleTime, 2);
        },
        totalRoundTime() {
            return math.multiply(
                this.ruleAddSceneForm.roundCount ? this.ruleAddSceneForm.roundCount : 0,
                this.totalCycleTime
            );
        }
    },
    created() {
        this.init();
    },
    methods: {
        //查看
        handleViewClick(id) {
            this.$router.push({ path: '/judges/scenemanagview/' + id });
        },
        //新建场次
        submitAddSceneForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let classId = this.$store.state.account.userinfo.classId;
                    this.ruleAddSceneForm.TeamID = classId;
                    debugger;
                    addRaceRecords(this.ruleAddSceneForm).then(response => {
                        if (response.success) {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.getlist();
                        }
                    });
                    this.dialogSceneVisible = false;
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        init() {
            this.enableModules = this.$store.state.account.userinfo.enableModules;
            getCategorys().then(response => {
                if (response.isSuccessful) {
                    this.categorys = response.data;
                }
            });
            this.getlist();
        },
        getlist() {
            let _this = this;
            let classId = this.$store.state.account.userinfo.classId;
            getRaceManager(_this.currentpage, _this.pagesize, classId).then(function (response) {
                _this.tableData = response.data;
                _this.pagetotal = response.pageRecord;
            });
        },
        handleCurrentChange(val) {
            this.currentpage = val;
            this.getlist();
        },
        showdialogScene() {
            this.dialogSceneVisible = true;
            this.ruleAddSceneForm.category = '';
            this.ruleAddSceneForm.duration = '';
            this.ruleAddSceneForm.name = '';
            this.ruleAddSceneForm.personnumber = 0;
        }
    }
};
</script>

<style></style>
